var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeFillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00304 14.7155C8.04093 12.8733 8.05988 11.9522 8.68099 11.1636C8.79436 11.0197 8.9607 10.8487 9.10011 10.7327C9.86393 10.0974 10.8724 10.0974 12.8893 10.0974C13.6099 10.0974 13.9702 10.0974 14.3137 10.0045C14.385 9.98522 14.4556 9.96296 14.5253 9.93781C14.8608 9.81675 15.1616 9.60837 15.7632 9.19161C18.137 7.54738 19.3239 6.72527 20.3201 7.08241C20.5111 7.15088 20.6959 7.24972 20.861 7.37162C21.7222 8.00744 21.7877 9.48675 21.9185 12.4454C21.967 13.5409 22 14.4785 22 15C22 15.5215 21.967 16.4591 21.9185 17.5546C21.7877 20.5132 21.7222 21.9926 20.861 22.6284C20.6959 22.7503 20.5111 22.8491 20.3201 22.9176C19.3239 23.2747 18.137 22.4526 15.7632 20.8084C15.1616 20.3916 14.8608 20.1833 14.5253 20.0622C14.4556 20.037 14.385 20.0148 14.3137 19.9955C13.9702 19.9026 13.6099 19.9026 12.8893 19.9026C10.8724 19.9026 9.86393 19.9026 9.10011 19.2673C8.9607 19.1513 8.79436 18.9803 8.68099 18.8364C8.05988 18.0478 8.04093 17.1267 8.00304 15.2845C8.00104 15.1878 8 15.0928 8 15C8 14.9072 8.00104 14.8122 8.00304 14.7155Z",
    fill: "#8E092E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeFillIcon);
export default __webpack_public_path__ + "static/media/volume-fill-icon.ec13152c4acc6fdbaed4e987d716b42d.svg";
export { ForwardRef as ReactComponent };